import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constant/Constant';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';

var UpdateImageAssetsAction = function () {

}


UpdateImageAssetsAction.prototype = {

    updateImageAssets: function (data) {

        restClient.updateImageAssets(data, function (error, response) {
            if (error) {
                if (error.status === 401) {
                    AppDispatcher.dispatch({
                        actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
                        data: error
                    });
                }
                else{
                    AppDispatcher.dispatch({
                    actionType: Constant.UPDATE_IMAGE_ASSETS,
                    data: error
                });
                }
            } else {
                response['status'] = 200;
                AppDispatcher.dispatch({
                    actionType: Constant.UPDATE_IMAGE_ASSETS,
                    data: response
                });
            }
        })
    }
}

export default new UpdateImageAssetsAction();